import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BlogPost } from '../../types/common';
import ActionButton from '../common/ActionButton';

export default function BlogSection() {
  const { t }: { t: (key: string) => string } = useTranslation();
  const [blogPosts, setBlogPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/data/blogPosts.json')
      .then((response) => response.json())
      .then((data: BlogPost[]) => {
        setBlogPosts(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error loading blog posts:', error);
        setLoading(false);
      });
  }, []);

  return (
    <section id="blog" className="pt-[100px]  bg-[#F2F4F8]">
      <div className="w-full max-w-[1280px] mx-auto px-6">
        <div className="mx-auto">
          <h2 className="text-2xl md:text-4xl font-bold text-center mb-16 text-[#1C2028]">
            {t('Blog.title')}
          </h2>
          {loading ? (
            <p className="text-center text-gray-500">{t('Blog.loading')}</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-6">
              {blogPosts.map((post) => (
                <a
                  key={post.blogUrl}
                  href={post.blogUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="rounded-lg overflow-hidden transition-all duration-300 hover:scale-105 cursor-pointer block w-full text-left bg-white flex flex-col"
                >
                  <img
                    className="w-full h-48 object-cover"
                    src={post.image}
                    alt={post.title}
                    loading="lazy"
                  />
                  <div className="p-5 pb-3 flex flex-col flex-grow justify-between">
                    <div>
                      <h3
                        className="text-base md:text-xl font-bold text-[#1C2028] transition-colors duration-200 mb-2 line-clamp-3"
                        style={{
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                          WebkitLineClamp: 3,
                        }}
                      >
                        {post.title}
                      </h3>
                      <p className="text-base font-normal text-gray-500">by {post.author}</p>
                    </div>
                    <span className="mt-10 text-p6 font-normal flex items-center w-fit transition-colors duration-200 text-[#1C2028]">
                      {t('Blog.readMore')}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
      <div
        className=" bg-gradient-to-b"
        style={{ backgroundImage: 'linear-gradient(to bottom, #F2F4F8, #FFFFFF)' }}
      >
        <div className="w-full max-w-[1280px] mx-auto px-6 pt-20 pb-2 flex flex-col items-center gap-10 justify-center">
          <p className="font-bold text-xl md:text-3xl">{t('Blog.moreInsights')}</p>
          <a href="https://medium.com/@iacloud_blog" target="_blank" rel="noopener noreferrer">
            <ActionButton label={t('Blog.viewAll')} type="orange" />
          </a>
        </div>
      </div>
    </section>
  );
}
